import InputField from 'components/InputField';
import Properties from 'components/Properties';
import { Button, Col, Input, InputNumber, Row, Select } from 'antd';
import { Fragment, useEffect, useState } from 'react';
import { clear_audience_customers, getAttributes } from 'services/audience_management';
import './index.css';
import { edit_Audience, getAttributeValues } from 'services/ManageCustomerBase';
import { CustomerBase } from 'config';
import Swal from 'sweetalert2';
import { t } from 'i18next';
import { escape, isEmpty } from 'lodash';
import { toast } from 'react-toastify';
import useRouter from 'hooks/useRouter';
import axios from 'axios';
import checkPermissionFunction from 'Permission';
import { formatNumber } from 'helpers';
import {
  DEFAULT_MIN_STAY_TIME,
  STAY_TIME_MAX_SECONDS,
  describeStayTime,
  getStayTimeErrors,
  toStayTimeNumber,
} from './stayTime';

export default function EditCondition(props) {
  const {
    id,
    sub_attribute,
    condition_value,
    show_condition,
    name,
    statusDefault,
    descriptionDefault,
    typeDefault,
    firebase,
    customize,
    stat,
    onSave,
    link,
    customerTotal,
    minStayTimeDefault,
    maxStayTimeDefault,
    onEmptied,
  } = props;
  const router = useRouter();
  const path = 'CustomerSet';
  const [chooseFile, set_choose_file] = useState(1);
  const [numberClickAnd, setNumberClickAnd] = useState([0]);
  const [Attributes, setAttributes] = useState([]);
  const [attributeValues, set_attributeValues] = useState({});
  const [selectProperties, setSelectProperties] = useState({});

  const [management, setManagement] = useState({});
  const [submanagement, setSubManagement] = useState({});
  const [showmanagement, setShowManagement] = useState({});

  const [name_audience, set_name_audience] = useState('');
  const [description, set_description] = useState('');
  const [firebaseTopic, set_firebaseTopic] = useState(1);
  const [status, set_status] = useState(1);
  const [customize_type, set_customize_type] = useState(1);
  // Thời gian ở tập, đơn vị giây. min mặc định 0 (không giữ chỗ), max null = vô hạn.
  const [min_stay_time, set_min_stay_time] = useState(DEFAULT_MIN_STAY_TIME);
  const [max_stay_time, set_max_stay_time] = useState(null);
  const [CustomerBase_Type, set_CustomerBase_Type] = useState([]);
  const [CustomerBase_Status, set_CustomerBase_Status] = useState([]);
  // true kể từ lúc gửi yêu cầu Empty: tập đang bị khóa ở backend nên phải chặn Lưu / Empty lại
  const [emptying, set_emptying] = useState(false);

  const [err, set_err] = useState({});

  useEffect(() => {
    setManagement(condition_value);
    setShowManagement(show_condition);
    setSubManagement(sub_attribute);
    set_name_audience(name);
    set_status(statusDefault);
    set_description(descriptionDefault);
    set_choose_file(typeDefault);
    set_firebaseTopic(firebase);
    set_customize_type(customize);
    set_status(stat);
    set_min_stay_time(toStayTimeNumber(minStayTimeDefault) ?? DEFAULT_MIN_STAY_TIME);
    set_max_stay_time(toStayTimeNumber(maxStayTimeDefault));

    let list = [];
    // console.log(condition_value);
    for (let id in condition_value) {
      list.push(Number(id));
    }
    setNumberClickAnd(list);
  }, [props]);

  useEffect(() => {
    async function freshData() {
      const value = await getAttributes();
      setAttributes(value.data.data);
      set_CustomerBase_Type(CustomerBase.type.filter((item) => item.id != 0));
      set_CustomerBase_Status(CustomerBase.status.filter((item) => item.id != 0));
    }
    freshData();
  }, []);

  async function getValues(id) {
    if (
      !(id in attributeValues) ||
      attributeValues[id] == undefined ||
      !attributeValues[id] == null
    ) {
      const value = await getAttributeValues(id);
      let obj = Object.assign({}, attributeValues);
      obj[id] = value.data.data;
      set_attributeValues(obj);
    }
  }

  // useEffect(() => {
  //     console.log(management);
  // }, [management]);

  function Notifire(text) {
    Swal.fire({
      title: t('Notification'),
      text: `${text} không được để trống`,
      icon: 'warning',
      confirmButtonText: t('Yes'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
      },
    });
  }

  async function OnSave() {
    if (emptying) return;
    if (name_audience == '') {
      const error = Object.assign({}, err);
      error.name = 'Chưa nhập tên khách hàng';
      set_err(error);
      return;
    } else {
      const error = Object.assign({}, err);
      delete error.name;
      set_err(error);
    }

    const stayTimeErrors = getStayTimeErrors({
      minStayTime: min_stay_time,
      maxStayTime: max_stay_time,
    });
    if (Object.keys(stayTimeErrors).length) {
      set_err(Object.assign({}, err, stayTimeErrors));
      return;
    }
    set_err((error) => {
      const next = Object.assign({}, error);
      delete next.minStayTime;
      delete next.maxStayTime;
      return next;
    });

    var formData = new FormData();
    formData.append('id', id);

    if (name_audience.trim().length > 500) {
      const error = Object.assign({}, err);
      error.name = 'Tên tập khách hàng có độ dài <= 500';
      set_err(error);
      return;
    }
    if (name != name_audience) formData.append('name', name_audience);
    if (descriptionDefault != description) formData.append('description', description);
    if (chooseFile != typeDefault) formData.append('type', chooseFile);
    if (firebaseTopic != firebase) formData.append('firebaseTopic', firebaseTopic || 1);

    /*
    Hai ô thời gian ở tập gửi thành một cặp: chỉ cần một ô đổi là gửi cả hai, để server
    kiểm tra ràng buộc "tối đa > tối thiểu" trên đúng cặp giá trị mới thay vì phải ghép
    với giá trị cũ trong DB. Ô tối đa để trống gửi chuỗi rỗng — đó là tín hiệu xóa giới
    hạn, đưa tập về vô hạn (khác với không gửi trường = giữ nguyên giá trị cũ).
    */
    const minStayTimeSaved = toStayTimeNumber(minStayTimeDefault) ?? DEFAULT_MIN_STAY_TIME;
    const maxStayTimeSaved = toStayTimeNumber(maxStayTimeDefault);
    const minStayTimeInput = toStayTimeNumber(min_stay_time) ?? DEFAULT_MIN_STAY_TIME;
    const maxStayTimeInput = toStayTimeNumber(max_stay_time);
    if (minStayTimeInput != minStayTimeSaved || maxStayTimeInput != maxStayTimeSaved) {
      formData.append('minStayTime', minStayTimeInput);
      formData.append('maxStayTime', maxStayTimeInput == null ? '' : maxStayTimeInput);
    }

    if (chooseFile == 1) {
      var file = document.getElementById('file').files[0];
      if (file != undefined && file != null) {
        formData.append('file', file);
      }
    } else {
        if (status == '') {
          Notifire('Trạng thái');
          return;
        }
        if (status != stat) formData.append('status', status);

        let values = Object.keys(management).map((item1) => {
          let values1 = Object.keys(management[item1]).map((item2) => {
            let values2 = Object.keys(management[item1][item2]).map((item3) => {
              return management[item1][item2][item3];
            });
            const sub_attribute = submanagement?.[item1]?.[item2];
            return values2.length === 1
              ? { ...values2[0], sub_attribute: sub_attribute }
              : { op: 'or', value: values2, sub_attribute: sub_attribute };
          });
          return values1.length === 1 ? values1[0] : { op: 'or', value: values1 };
        });
        if (values.length == 0) {
          Swal.fire({
            title: t('Notification'),
            text: 'Vui lòng nhập đầy đủ thông tin',
            icon: 'warning',
            confirmButtonText: t('Yes'),
            customClass: {
              confirmButton: 'btn btn-danger font-weight-bolder',
            },
          });
          return;
        }
        let obj = values.length === 1 ? values[0] : { op: 'and', value: values };
        console.log(obj);
        console.log('a: ', JSON.stringify(obj));
        // console.log(management);
        formData.append('condition', JSON.stringify(obj));
        formData.append('subAttribute', JSON.stringify(submanagement));
        formData.append('conditionValue', JSON.stringify(management));
        formData.append('showCondition', JSON.stringify(showmanagement));
        if (customize_type != customize) formData.append('customizeType', customize_type);
    }

    try {
      const res = await edit_Audience(formData);
      if (res.data.status == 1) {
        await Swal.fire({
          title: t('Notification'),
          text: 'Sửa tập khách hàng thành công',
          icon: 'success',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          },
        }).then(async function (result) {
          if (result.value) {
            onSave();
          }
        });
      } else {
        Swal.fire({
          title: t('Notification'),
          text: res.showMessage ?? 'Sửa tập khách hàng thất bại',
          icon: 'success',
          confirmButtonText: t('Yes'),
          customClass: {
            confirmButton: 'btn btn-danger font-weight-bolder',
          },
        });
      }
      return;
    } catch (err) {
      Swal.fire({
        title: t('Notification'),
        text: err.response?.data?.showMessage ?? 'Sửa tập khách hàng thất bại',
        icon: 'warning',
        confirmButtonText: t('Yes'),
        customClass: {
          confirmButton: 'btn btn-danger font-weight-bolder',
        },
      });
    }
  }

  async function OnEmpty() {
    if (emptying) return;

    // Tập tùy chỉnh (type = 2) đang "Đã duyệt" sẽ bị backend hạ về "Chưa duyệt" sau khi dọn.
    // Dựa trên giá trị đã lưu (typeDefault / stat) chứ không phải giá trị đang chọn trên form.
    const willDowngradeStatus = typeDefault == 2 && stat == 1;
    const total = formatNumber(customerTotal);

    const confirm = await Swal.fire({
      title: 'Empty tập khách hàng',
      html: `
        <div style="text-align: left">
          <p>Toàn bộ khách hàng sẽ bị xóa khỏi tập <b>${escape(name_audience || name || '')}</b>${
        total !== '' ? ` (hiện có <b>${total}</b> khách hàng)` : ''
      }, tập sẽ còn 0 thành viên.</p>
          <p>Tập vẫn tồn tại: tên, mô tả, điều kiện lọc và file Excel gốc đều được giữ nguyên.</p>
          ${
            willDowngradeStatus
              ? '<p class="text-danger"><b>Lưu ý:</b> tập này đang ở trạng thái <b>Đã duyệt</b> và sẽ bị hạ về <b>Chưa duyệt</b>. Cột trạng thái ở bảng danh sách sẽ thay đổi theo.</p>'
              : ''
          }
          <p>Việc dọn dữ liệu chạy ngầm, tập lớn có thể mất vài phút. Trong lúc đó tập bị khóa: không thể sửa, chuyển đổi hay dọn lại.</p>
          <p class="text-danger"><b>Hành động này không thể hoàn tác.</b></p>
        </div>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Empty tập khách hàng',
      cancelButtonText: t('Cancel'),
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    });

    if (!confirm.isConfirmed) return;

    set_emptying(true);
    try {
      await clear_audience_customers(id);
      await Swal.fire({
        title: t('Notification'),
        text: 'Đã gửi yêu cầu Empty tập khách hàng. Hệ thống đang dọn ngầm, tập lớn có thể mất vài phút mới về 0 khách hàng.',
        icon: 'success',
        confirmButtonText: t('Yes'),
        customClass: {
          confirmButton: 'btn btn-primary font-weight-bolder',
        },
      });
      // Giữ emptying = true để không cho Lưu / Empty lại trong lúc backend đang khóa tập
      if (onEmptied) onEmptied(id);
      else onSave();
    } catch (err) {
      set_emptying(false);
      Swal.fire({
        title: t('Notification'),
        text:
          err.response?.data?.showMessage ??
          err.response?.data?.message ??
          'Empty tập khách hàng thất bại',
        icon: 'warning',
        confirmButtonText: t('Yes'),
        customClass: {
          confirmButton: 'btn btn-danger font-weight-bolder',
        },
      });
    }
  }

  async function GetFile() {
    try {
      const response = await axios.get(link, {
        responseType: 'blob', // Ensures the response is a Blob
      });

      const fileName = link.substring(link.lastIndexOf('/') + 1); // Extract file name from URL

      // Create a URL for the Blob
      const fileURL = URL.createObjectURL(response.data);

      // Create a link element and trigger the download
      const a = document.createElement('a');
      a.href = fileURL;
      a.download = fileName; // Set the downloaded file name
      document.body.appendChild(a);
      a.click(); // Trigger download
      document.body.removeChild(a); // Remove the link element

      // Release URL object
      URL.revokeObjectURL(fileURL);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }

  return (
    <div className="container-fluid">
      <div className="bg-white card pt-5">
        <div className="card-header border-0 pt-6 pb-0">
          <div className="w-100 d-flex justify-content-between">
            <div className="card-title my-0">
              <h3 className="card-label">
                <b>SỬA TẬP KHÁCH HÀNG</b>{' '}
              </h3>
            </div>
          </div>
        </div>
        <div className="card-body py-3 d-flex flex-column min-h-100 gap-4">
          <Row justify="space-between">
            <Col span={10}>
              <div>
                <div>Tên tập khách hàng (*)</div>
                <Input
                  placeholder="Tên tập khách hàng"
                  defaultValue={name}
                  style={{ width: '100%' }}
                  onChange={(e) => set_name_audience(e.target.value)}
                />
                {err?.name && (
                  <div className="fv-plugins-message-container">
                    <div className="fv-help-block">{err?.name}</div>
                  </div>
                )}
              </div>
            </Col>
            <Col span={10}>
              <div>
                <div>Loại tập khách hàng (*)</div>
                <Select
                  disabled={true}
                  defaultValue={CustomerBase.type.find((item) => item.id == typeDefault)?.name}
                  style={{
                    width: '100%',
                  }}
                  onChange={(e) => set_choose_file(e)}
                  options={CustomerBase_Type.map((item) => {
                    return { label: item.name, value: item.id };
                  })}
                />
              </div>
            </Col>
          </Row>

          <div>
            <div>Mô tả</div>
            <Input
              placeholder="Nhập mô tả"
              defaultValue={descriptionDefault}
              // style={{ width: '400px' }}
              onChange={(e) => {
                set_description(e.target.value);
              }}
            />
          </div>
          <Row justify="space-between">
            <Col span={10}>
              <div>Thời gian ở tập tối thiểu (giây)</div>
              <InputNumber
                className="w-100"
                placeholder="0"
                min={0}
                max={STAY_TIME_MAX_SECONDS}
                step={60}
                precision={0}
                value={min_stay_time}
                onChange={(value) => set_min_stay_time(value)}
              />
              <div className="text-muted" style={{ fontSize: '12px' }}>
                Chưa ở đủ thời gian này thì khách không bị kích ra khỏi tập. Để trống hoặc 0 = không
                giữ chỗ. {describeStayTime(min_stay_time)}
              </div>
              {err?.minStayTime && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{err?.minStayTime}</div>
                </div>
              )}
            </Col>
            <Col span={10}>
              <div>Thời gian ở tập tối đa (giây)</div>
              <InputNumber
                className="w-100"
                placeholder="Để trống = vô hạn"
                min={1}
                max={STAY_TIME_MAX_SECONDS}
                step={60}
                precision={0}
                value={max_stay_time}
                onChange={(value) => set_max_stay_time(value)}
              />
              <div className="text-muted" style={{ fontSize: '12px' }}>
                Khách không được ở trong tập quá thời gian này. Để trống = vô hạn.{' '}
                {describeStayTime(max_stay_time)}
              </div>
              {err?.maxStayTime && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{err?.maxStayTime}</div>
                </div>
              )}
            </Col>
          </Row>
          {chooseFile == 1 ? (
            <div>
              <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Tải file khách hàng (.csv, .xlsx, .xls)
              </label>
              <Row justify="space-between">
                <Col span={link != null ? 20 : 24}>
                  <input
                    className="block w-full text-lg text-gray-900 border border-gray-300 rounded-sm cursor-pointer focus:outline-none"
                    type="file"
                    accept=".csv, text/csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    id="file"
                  />
                </Col>

                <Col span={3} className="flex justify-end">
                  {link != null && (
                    <Button
                      onClick={() => {
                        GetFile();
                      }}
                    >
                      Tải file
                    </Button>
                  )}
                </Col>
              </Row>
              {err?.file && (
                <div className="fv-plugins-message-container">
                  <div className="fv-help-block">{err?.file}</div>
                </div>
              )}
              <a href="/data.xlsx" download>
                Tải xuống file Excel mẫu
              </a>
            </div>
          ) : (
            <div className="flex flex-col gap-3">
              <label>Danh sách thuộc tính lọc</label>
              {numberClickAnd.map((item, i) => (
                <Fragment key={i}>
                  <div className="border-1 gap-3" key={i}>
                    <Properties
                      defaultValue={condition_value[item]}
                      defaultOption={show_condition[item]}
                      defaultSubOption={sub_attribute[item]}
                      property={Attributes}
                      change={(item) => {
                        if (item.length == 0) {
                          let data = [...numberClickAnd];
                          data.splice(i, 1);
                          setNumberClickAnd(data);
                        }
                      }}
                      indexId={i}
                      attributeChange={(item) => {
                        getValues(item);
                        let obj = Object.assign({}, selectProperties);
                        obj[i] = item;
                        setSelectProperties(obj);
                      }}
                      option={attributeValues[selectProperties[i]]}
                      onChange={(item) => {
                        let obj = Object.assign({}, management);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setManagement(obj);
                        } else {
                          obj[i] = item;
                          setManagement(obj);
                        }
                      }}
                      onChangeSub={(item) => {
                        let obj = Object.assign({}, submanagement);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setSubManagement(obj);
                        } else {
                          obj[i] = item;
                          setSubManagement(obj);
                        }
                      }}
                      onChangeShow={(item) => {
                        let obj = Object.assign({}, showmanagement);
                        if (isEmpty(item)) {
                          delete obj[i];
                          setShowManagement(obj);
                        } else {
                          obj[i] = item;
                          setShowManagement(obj);
                        }
                      }}
                    />
                  </div>
                  {i != numberClickAnd.length - 1 && <span>AND</span>}
                </Fragment>
              ))}
              <div>
                <div
                  className="btn btn-primary"
                  onClick={() => {
                    let data = [...numberClickAnd];
                    data.push(Math.max(...numberClickAnd) + 1);
                    setNumberClickAnd(data);
                  }}
                >
                  AND
                </div>
              </div>
            </div>
          )}
          <div>
            <div className="row">
              <div className="col-sm flex flex-col">
                <div>Push notification</div>
                <Select
                  disabled={true}
                  defaultValue={
                    CustomerBase.Firebase_Topic.find((item) => item.id == firebase)?.name
                  }
                  style={{
                    width: '100%',
                  }}
                  onChange={(e) => set_firebaseTopic(e)}
                  options={CustomerBase.Firebase_Topic.map((item) => {
                    return { label: item.name, value: item.id };
                  })}
                />
              </div>
              <div className="col-sm flex flex-col justify-end">
                {chooseFile == 2 && (
                  <div>
                    <div>customize_type (*)</div>
                    <Select
                      defaultValue={
                        CustomerBase.customize_type.find((item) => item.id == customize)?.name
                      }
                      style={{
                        width: '100%',
                      }}
                      onChange={(e) => set_customize_type(e)}
                      options={CustomerBase.customize_type.map((item) => {
                        return { label: item.name, value: item.id };
                      })}
                    />
                  </div>
                )}
              </div>
              {chooseFile == 2 && (
                <div className="col-sm flex flex-col justify-end">
                  <div>Trạng thái (*)</div>
                  <Select
                    defaultValue={CustomerBase.status.find((item) => item.id == stat)?.name}
                    style={{
                      width: '100%',
                    }}
                    onChange={(e) => set_status(e)}
                    options={CustomerBase_Status.map((item) => {
                      return { label: item.name, value: item.id };
                    })}
                  />
                </div>
              )}
            </div>
          </div>
          <div>
            <div className="row">
              <div className="col-sm-12">
                <div className="d-flex justify-content-end flex-wrap gap-5">
                  <span className="btn btn-bg-secondary" onClick={() => onSave()}>
                    Hủy
                  </span>
                  <span
                    className={`btn btn-light-danger btn-hover-bg-danger font-weight-bold ${
                      emptying ? 'disabled' : ''
                    }`}
                    title="Xóa toàn bộ khách hàng khỏi tập, tập vẫn được giữ lại"
                    onClick={() => {
                      if (emptying) return;
                      checkPermissionFunction(path, 'delete', () => OnEmpty());
                    }}
                  >
                    <i className="fa fa-eraser icon-sm" />
                    Empty tập khách hàng
                  </span>
                  <span
                    className={`btn btn-primary ${emptying ? 'disabled' : ''}`}
                    onClick={() => {
                      OnSave();
                    }}
                  >
                    Lưu
                  </span>
                </div>
                {emptying && (
                  <div className="text-muted text-right mt-2" style={{ fontSize: '12px' }}>
                    <span
                      className="spinner-border spinner-border-sm text-warning mr-2"
                      role="status"
                    ></span>
                    Đang dọn tập khách hàng ở nền, tạm khóa thao tác sửa trên tập này.
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
